<template>
  <div class="auth-template">
      <main>
        <slot name="main"></slot>
      </main>
  </div>
</template>

<script>

export default {
  name: 'AuthTemplate',
  data() {
    return{

    }
  },
  mounted() {
    console.log(this.$route.name);
  },
  components: {

  },
  methods : {

  }
}
</script>

<style scoped>

.auth-template {
  height: 100vh;
  background: var(--BG, #F8F8F8);
  display: flex;
  justify-content: center;
  align-items: center;
}

main {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  padding: 30px;
  width: 483px;
}






/*MOBILE*/
@media (max-width: 1250px)
{
  .auth-template {
    padding: 0px 15px;
  }

  main {
    width: 100%;
    padding: 20px 18px;
  }
}

</style>

<style>
.form {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
}

.head {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

h3.title {
  color: var(--Black, #222);
  text-align: center;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  margin: 0px;
  text-align: center;
}

p.sub_title_text {
  color: var(--Gray, #656565);
  text-align: center;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  margin: 0px;
  text-align: center;
  width: 255px;
}

.body {
  width: 100%;
}

/*MOBILE*/
@media (max-width: 1250px)
{
  .form {
    gap: 24px;
    align-items: start;
  }

  h3.title {
    text-align: start;
  }

  p.sub_title_text {
    text-align: start;
  }
}
</style>